var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIconMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "259.8999938964844 338.8000183105469 10 12.0999755859375",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "deletesmZCI"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M260.7 349.4c0 .8.7 1.5 1.5 1.5h5.5c.8 0 1.5-.7 1.5-1.5v-7.5h-8.5v7.5zm2.3-5.4c0-.3.2-.5.5-.5s.5.2.5.5v4c0 .3-.2.5-.5.5s-.5-.2-.5-.5v-4zm6.9-4.4v1.5h-10v-1.5h2.2l.8-.8h4l.8.8h2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M266.5 348.5c-.3 0-.5-.2-.5-.5v-4c0-.3.2-.5.5-.5s.5.2.5.5v4c0 .2-.2.5-.5.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIconMail);
export default __webpack_public_path__ + "static/media/deleteIconMail.c21d6a9906e87f7394febf9422808de9.svg";
export { ForwardRef as ReactComponent };